import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import {blue500, grey25, greyishBlue100, greyishBlue600} from "assets/jss/main";

ListingSelectTotalBanner.propTypes = {
    message: PropTypes.node.isRequired,
    actionLabel: PropTypes.node.isRequired,
    onAction: PropTypes.func.isRequired,
};

const Banner = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '12px 20px',
    marginBottom: '16px',
    backgroundColor: grey25,
    border: `1px solid ${greyishBlue100}`,
    borderRadius: '8px',
    color: greyishBlue600,
    fontSize: '14px',
    fontWeight: 400
});

const ActionLabel = styled('span')({
    color: blue500,
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap'
});

function ListingSelectTotalBanner({message, actionLabel, onAction}) {
    return (
        <Banner>
            <span>{message}</span>
            <ActionLabel
                onClick={(event) => {
                    event.stopPropagation();
                    onAction(event);
                }}
            >
                {actionLabel}
            </ActionLabel>
        </Banner>
    );
}

export default ListingSelectTotalBanner;
